import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../shared/utils/request";
import PageLoader from "../shared/pageLoader";
import ProductViewV2 from "../shared/productViewV2";
import { EmptyProducts } from "../shared/warningPages";

const CollectionsPage = () => {
  const { slug } = useParams();
  const isSubCategory = window.location.pathname.includes("sub-category");

  const [products, setProducts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const limit = 12;

  const fetchProducts = async (currentOffset = 0) => {
    try {
      if (currentOffset === 0) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }
      const payload = {
        limit,
        offset: currentOffset,
        category_slug: isSubCategory ? null : slug,
        subcategory_slug: isSubCategory ? slug : null,
        search: null,
        sort_by: "id",
        sort_order: "desc",
      };
      const data = await api.post("customer/getProducts", payload);
      const items = data?.data || data?.products || [];
      const total = data?.total_count ?? products.length + items.length;
      setTotalCount(total);
      if (currentOffset === 0) {
        setProducts(items);
      } else {
        setProducts((prev) => [...prev, ...items]);
      }
      setHasMore(total > (currentOffset + 1) * limit);
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    setOffset(0);
    setProducts([]);
    setTotalCount(0);
    fetchProducts(0);
  }, [slug, isSubCategory]);

  const loadMore = () => {
    const nextOffset = parseInt(offset) + 1;
    setOffset(nextOffset);
    fetchProducts(nextOffset);
  };

  return (
    <section className="py-40 overflow-hidden">
      <div className="container container-lg">
        {loading && <PageLoader />}

        <div className="mb-32">
          <h3 className="fw-bold text-main-700 mb-8">Fugu's Collections</h3>
          <p className="text-neutral-600 text-sm mb-0">
            {totalCount} product{totalCount !== 1 ? "s" : ""} found
          </p>
        </div>

        {!loading && products.length === 0 && <EmptyProducts />}

        {products.length > 0 && (
          <div className="row g-12">
            {products.map((product, index) => (
              <ProductViewV2
                key={index}
                product={{
                  id: product?.id,
                  slug: product?.product?.slug,
                  variant_id: product?.id,
                  image: product?.product_image,
                  name: product?.title,
                  price: product?.sale_price,
                  originalPrice: product?.price,
                  quantityType: product?.quantity,
                  sold: product?.stock,
                  label: product?.label,
                }}
              />
            ))}
          </div>
        )}

        {hasMore && products.length > 0 && (
          <div className="text-center mt-40">
            <button
              onClick={loadMore}
              disabled={loadingMore}
              className="btn btn-outline-main px-40 py-12 rounded-pill fw-semibold"
            >
              {loadingMore ? (
                <span
                  className="spinner-border spinner-border-sm me-4"
                  aria-hidden="true"
                />
              ) : null}
              Load More
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default CollectionsPage;
